import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import assets from 'modules/assets'
import * as actions from 'actions'

class MenuGallery extends Component {
  constructor(props) {
    super(props)

    this.MENU_FILE = 'menu_gallery_2016.md'
    this.defaultText = {
      P1: 'We are a global community of creators using design, technology and pedagogy to reinvent learning.',
      P2: 'We’re building a new kind of learning environment from the ground up — one that turns students into lifelong learners and, better yet, creative educators.'
    }
    this.state = {
      menuState: false,
      menuUrl: this.MENU_FILE,
      textP1: this.defaultText.P1,
      textP2: this.defaultText.P2
    }
  }
  componentDidMount() {
    let { dispatch } = this.props
    let url = assets(this.state.menuUrl)//assets('menu.md')
    dispatch(actions.token.fetchMenu(url))
  }
  toggleMenu = () => {
    this.props.dispatch(actions.token.toggleMenu(!this.state.menuState))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      menuState: nextProps.menuState,
      isFetchingMenu: nextProps.isFetchingMenu,
      menuData: nextProps.menuData,
      isNavigateGallery: nextProps.isNavigateGallery
    })
  }
  updateText(textObj) {
    if (textObj.P1 || textObj.P2) {
      if (textObj.P1 == '' && textObj.P2 == '')
        return

      this.setState({
        textP1: textObj.P1,
        textP2: textObj.P2
      })
    }
  }
  close = () => {
    this.toggleMenu()
  }
  clickShareButton(url) {
    window.open(url, 'Share on Facebook!', 'left=20,top=20,width=500,height=500,toolbar=1,resizable=0')
    return false
  }
  //                 <h4><b><Link to={'/'} onClick={this.close} style={{marginBottom: '25px'}}>{'<<'} Return Home</Link></b></h4>
  render() {
    // default menu language is English
    let menuOptions = {}
    if (this.state.menuData) {
      menuOptions = this.state.menuData[parseInt(this.props.params.year)]
    }

    if (!menuOptions) return null

    let menu = <div className="slide-out"></div>
    if (this.state.menuState && this.state.menuData && this.state.isNavigateGallery) {
      menu = (
        <div className='menu menu-camp-2016 app-body fade-in'>
          <div className="main-grid">
            <ul className="grid group menu-top">
              <li className="grid-small"><span className="close-menu" onClick={this.toggleMenu}>×</span></li>
            </ul>
          </div>
          <div className="main-grid">
            <ul className="grid group menu-options">
              <li className="grid-small">
                {Object.keys(menuOptions).map((key, i) => {
                  // If it's an anchor or external link, do a href.
                  // Otherwise, do <Link> component, for smooth transitions.
                  let customText = {
                    P1: menuOptions[key].textP1,
                    P2: menuOptions[key].textP2
                  }
                  let selectedClassName = ''
                  let fontWeight = 400
                  if (menuOptions[key].id == this.props.params.campid) {
                    selectedClassName = 'sectra'
                    fontWeight = 300
                  }

                  if (menuOptions[key].link.indexOf('#') != -1 || menuOptions[key].link.indexOf('http://') != -1) {
                    if (menuOptions[key].link[0] == '\\')
                      menuOptions[key].link = menuOptions[key].link.substring(1)
                    return (
                      <span key={key}>
                        <div className={selectedClassName} style={{fontWeight: fontWeight, fontSize: '48pt'}}><b><a href={menuOptions[key].link} onClick={this.close} onMouseEnter={this.updateText.bind(this, customText)} onMouseOut={this.updateText.bind(this, this.defaultText)}>{menuOptions[key].display} </a></b></div>
                      </span>
                    )
                  } else {
                    return (
                      <span key={key}>
                        <div className={selectedClassName} style={{fontWeight: fontWeight, fontSize: '48pt'}}><b><Link to={menuOptions[key].link} onClick={this.close} onMouseEnter={this.updateText.bind(this, customText)} onMouseOut={this.updateText.bind(this, this.defaultText)}>{menuOptions[key].display}</Link></b></div>
                      </span>
                    )}
                })}
              </li>
            </ul>
          </div>
          <div className="main-grid">
            <ul className="grid group menu-top">
              <li className="grid-small">
                <a className='logo' href='/'>
                  <img src={assets('images/logos/gakko-logo.png')} style={{marginTop: '50px', marginLeft: '3px', height: '20px', 'width': 'auto'}}/>
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    }

    return menu
  }
}
MenuGallery.contextTypes = {
}
MenuGallery.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    menuState: state.token.menuState,
    isFetchingMenu: state.token.isFetchingMenu,
    menuData: state.token.menuData,
    isNavigateGallery: state.token.isNavigateGallery
  }
}

export default connect(mapStateToProps)(MenuGallery)



// WEBPACK FOOTER //
// ./src/components/Gallery/MenuGallery.js